var React = require('react');

function CategoryDogsAreGood (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"2","cy":"5.6","r":"2","key":0}),React.createElement("circle",{"cx":"5.6","cy":"2.4","r":"2","key":1}),React.createElement("circle",{"cx":"10.4","cy":"2.4","r":"2","key":2}),React.createElement("circle",{"cx":"14","cy":"5.6","r":"2","key":3}),React.createElement("path",{"d":"M12.3,9.9c-0.7-0.8-1.3-1.5-2-2.3C9.9,7.1,9.4,6.7,8.9,6.5c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0\n\t\tc-0.1,0-0.2,0-0.3,0.1c-0.6,0.2-1,0.6-1.4,1.1C5,8.4,4.4,9.1,3.7,9.9c-1,1-2.3,2.2-2.1,3.8c0.2,0.8,0.8,1.6,1.9,1.9\n\t\tc0.6,0.1,2.4-0.4,4.4-0.4h0.1c2,0,3.8,0.5,4.4,0.4c1-0.2,1.6-1,1.9-1.9C14.6,12.1,13.3,10.9,12.3,9.9z","key":4})]);
}

CategoryDogsAreGood.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16"};

module.exports = CategoryDogsAreGood;

CategoryDogsAreGood.default = CategoryDogsAreGood;
